export const arraysAreEqual = (a, b) => {
    if (!Array.isArray(a) || !Array.isArray(b)) {
        return false;
    }
    return a.length === b.length && a.every((element, i) => element === b[i]);
};
